module.exports = __webpack_public_path__ + "img/homepage_04.40254ff4.jpg";